import { useContext } from "react";
import IpLocationContext, { ContextValue } from "../context/IpLocationContext";

export default function useIpLocation(): ContextValue {
  const ctx = useContext(IpLocationContext);
  if (ctx === undefined) throw new Error("useIpLocation must be used within an IpLocationProvider");
  return ctx as ContextValue;
}
